import styled from 'styled-components';
import { Button } from 'antd';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

export const StyledBackButton = styled(Button)`
  && {
    width: 36px;
    min-width: 36px;
    height: 36px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: ${defaultTheme.theme.palette.secondary.main};
    border: 1px solid ${defaultTheme.theme.palette.secondary.main};
    border-radius: 8px;
    box-shadow: none;
  }

  &&:hover,
  &&:focus-visible {
    background: ${defaultTheme.theme.palette.secondary.main} !important;
    border-color: ${defaultTheme.theme.palette.secondary.main} !important;
    opacity: 0.85;
  }

  svg {
    display: block;
  }
`;
